import { useState } from "react";
import { apiDelete } from "../../services/api.service";
import { showError, showSuccess } from "../../services/notification.service";

export const useDeleteGroup = (groupId?: number) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const deleteGroup = async (id?: number): Promise<boolean> => {
		const targetId = id || groupId;
		
		if (!targetId) {
			showError("No group ID provided");
			return false;
		}

		setLoading(true);
		setError(null);

		try {
			const response = await apiDelete(`/groups/${targetId}`);

			if (response.success) {
				showSuccess(response.message || "Group deleted successfully");
				return true;
			} else {
				const errorMsg = response.message || "Failed to delete group";
				setError(errorMsg);
				showError(errorMsg);
				return false;
			}
		} catch (err: any) {
			const errorMsg = err?.message || "Failed to delete group";
			setError(errorMsg);
			showError(errorMsg);
			return false;
		} finally {
			setLoading(false);
		}
	};

	return {
		deleteGroup,
		loading,
		error,
	};
};